<template>
  <div class="p-4">
    <button @click="createMicroCategory" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 mb-6 rounded">
      New MicroCategory
    </button>
    <el-table
      :data="microCategories"
      :empty-text="'No Micro Category available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name">
      </el-table-column>
      <el-table-column
        prop="category"
        label="Category">
      </el-table-column>
      <el-table-column
        prop="subCategory"
        label="Sub-category">
      </el-table-column>
      <el-table-column
        prop="image"
        label="Image">
        <template slot-scope="scope">
          <a class="text-blue-500 italic hover:underline" v-if="scope.row.image" :href="scope.row.image" target="_blank">
            <img :src="scope.row.image" alt="">
          </a>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="">
        <template slot-scope="scope">
          <span @click="updateMicroCategory(scope.row)">
            <i class="text-blue-400 cursor-pointer mr-4 text-sm el-icon-edit"></i>
          </span>
          <el-button @click="deleteMicroCategory(scope.row.id, scope.row.sub_category_id)" type="text" size="small">
            <i class="text-sm text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <CreateForm @imageUpload="imageUpload" />
    <UpdateForm :upload_url="url" />
    <ImageUpload :url="url" />
  </div>
</template>

<script>
import { flatMap } from 'lodash';
import CreateForm from './_includes/MicroCategory/CreateForm.vue';
import UpdateForm from './_includes/MicroCategory/UpdateForm.vue';
import ImageUpload from './_includes/ImageUpload.vue';

export default {
  name: 'MicroCategory',
  components: {
    CreateForm,
    UpdateForm,
    ImageUpload,
  },
  data() {
    return {
      url: '',
    };
  },
  computed: {
    microCategories() {
      if (this.$route.params.subCategory_id) {
        return this.$store.getters['InventoryModule/Catalog/getMicroCategoryBySubCategory'](this.$route.params.subCategory_id);
      }
      return flatMap(this.$store.state.InventoryModule.Catalog.microCategories);
    },
  },
  methods: {
    createMicroCategory() {
      this.$modal.show('new-micro-category');
    },

    async updateMicroCategory(microCategory) {
      this.url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${microCategory.id}/images?type=micro_categories`;
      await this.$store.commit('InventoryModule/Catalog/setCurrentSelected', { property: 'microCategory', payload: microCategory });
      this.$modal.show('update-micro-category');
    },

    deleteMicroCategory(microCategoryId, subCategoryId) {
      this.$confirm('This will permanently delete the sub-category and micro-categories under it. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Catalog/deleteMicroCategory', { microCategoryId, subCategoryId });
          this.$notify.success({
            title: 'Success',
            message: 'Category successfully deleted',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },

    imageUpload(id) {
      this.$modal.hide('new-micro-category');
      this.$modal.show('image-upload');

      this.url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${id}/images?type=micro_categories`;
    },
  },
};
</script>

<style scoped>
  img {
    height: 50px;
    width: 70px;
    border-radius: 4px;
    object-fit: cover;
  }
</style>
